import React, { useState, useEffect } from 'react';
import { api } from '../api';
import { useAppContext } from '../context/AppContext';

const OPERATOR_PHONE = '+79534933334';
const OPERATOR_PHONE_DISPLAY = '+7 (953) 493-33-34';

export default function HomeScreen() {
  const { user } = useAppContext();
  const [announcement, setAnnouncement] = useState(null);

  useEffect(() => {
    api.announcements.active().then(d => { if (d?.message) setAnnouncement(d.message); }).catch(() => {});
  }, []);

  const greeting = user?.name ? `Добро пожаловать, ${user.name}! 👋` : 'Добро пожаловать! 👋';

  return (
    <div style={{ padding: '0 16px 100px' }}>
      {announcement && (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, background: '#FF950022', borderLeft: '4px solid #FF9500', borderRadius: 10, padding: '10px 12px', marginTop: 16 }}>
          <span style={{ fontSize: 18 }}>📢</span>
          <p style={{ fontSize: 14, color: 'var(--text)', lineHeight: 1.5, fontWeight: 500 }}>{announcement}</p>
        </div>
      )}

      <div style={{ marginTop: 24, marginBottom: 24 }}>
        <h1 style={{ fontSize: 26, fontWeight: 'bold', color: 'var(--primary)' }}>{greeting}</h1>
        <p style={{ fontSize: 15, color: 'var(--text-light)', marginTop: 4 }}>Акватория — чистая вода для вас</p>
      </div>

      <div style={cardStyle}>
        <h3 style={cardTitle}>🕐 График работы Оператора</h3>
        <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 4 }}>
          <span style={{ fontSize: 14 }}>Пн — Вс</span>
          <span style={{ fontSize: 14, color: 'var(--primary)', fontWeight: 600 }}>08:00 — 19:00</span>
        </div>
      </div>

      <div style={cardStyle}>
        <h3 style={cardTitle}>💧 О нашей воде</h3>
        <p style={{ fontSize: 14, color: 'var(--text-light)', lineHeight: 1.6 }}>
          Вся вода проходит многоступенчатую систему очистки и соответствует стандартам ГОСТ. Мы сотрудничаем только с проверенными производителями.
        </p>
      </div>

      <div style={cardStyle}>
        <h3 style={cardTitle}>✅ Преимущества</h3>
        {['🚚 Доставка от 2 часов', '📦 Бесплатная доставка от 2 бутылей', '🔄 Принимаем бутыли любой фирмы', '💳 Оплата переводом или наличными'].map(b => (
          <p key={b} style={{ fontSize: 14, color: 'var(--text)', paddingTop: 4, paddingBottom: 4 }}>{b}</p>
        ))}
      </div>

      <div style={{ ...cardStyle, textAlign: 'center' }}>
        <h3 style={cardTitle}>📞 Контакты</h3>
        <a href={`tel:${OPERATOR_PHONE}`} style={{ display: 'block', textDecoration: 'none' }}>
          <p style={{ fontSize: 22, fontWeight: 'bold', color: 'var(--primary)' }}>{OPERATOR_PHONE_DISPLAY}</p>
          <p style={{ fontSize: 13, color: 'var(--secondary)', marginTop: 4 }}>Нажмите, чтобы позвонить</p>
        </a>
      </div>
    </div>
  );
}

const cardStyle = { background: 'var(--card)', borderRadius: 14, padding: 16, marginBottom: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' };
const cardTitle = { fontSize: 17, fontWeight: 700, color: 'var(--text)', marginBottom: 12 };
